"use client";

import React, { useEffect, useState } from "react";
import { Progress } from "@/components/ui/progress";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const benchmarks = [{
  id: 1,
  label: "THE PHILOSOPHY",
  value: 0,
  suffix: "% HYPE",
  targetProgress: 5,
  description: "We eliminate startup theater and empty promises. Our focus is on sustainable growth over vanity metrics."
}, {
  id: 2,
  label: "THE COMMITMENT",
  value: 100,
  suffix: "% EXECUTION",
  targetProgress: 100,
  description: "Strategic clarity is worthless without the drive to ship. We turn complex visions into functional realities."
}, {
  id: 3,
  label: "THE DNA",
  value: 100,
  suffix: "% OPERATOR-LED",
  targetProgress: 100,
  description: "No career consultants. You work with operators who have successfully built, scaled, and exited ventures."
}];
export default function GlobalImpactBenchmarks() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  const [animatedValues, setAnimatedValues] = useState(benchmarks.map(() => ({
    number: 0,
    progress: 0
  })));
  useEffect(() => {
    if (isVisible) {
      const duration = 2000;
      const steps = 60;
      const intervalTime = duration / steps;
      let currentStep = 0;
      const timer = setInterval(() => {
        currentStep++;
        const progressRatio = Math.min(currentStep / steps, 1);
        const ease = 1 - Math.pow(1 - progressRatio, 4);
        setAnimatedValues(benchmarks.map(item => ({
          number: Math.round(item.value * ease),
          progress: item.targetProgress * ease
        })));
        if (currentStep >= steps) {
          clearInterval(timer);
        }
      }, intervalTime);
      return () => clearInterval(timer);
    }
  }, [isVisible]);
  return <section data-section-id="34826" id="why-1066" ref={ref} className="dark bg-background text-foreground py-24 relative border-y border-border shadow-none overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,var(--color-primary)_0%,transparent_10%)] opacity-5 blur-3xl pointer-events-none" />
      
      <div className="container mx-auto px-6 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 lg:gap-24">
          {benchmarks.map((item, index) => <div key={item.id} data-index={index} className="flex flex-col gap-6 group">
              {}
              <div className="flex flex-col">
                <span className="text-sm font-default font-medium tracking-widest text-muted-foreground uppercase mb-2">
                  {item.label}
                </span>
                <div className="flex items-baseline gap-1">
                  <span className="text-6xl md:text-7xl font-default font-medium tracking-tighter text-foreground">
                    {animatedValues[index].number}
                  </span>
                  <span className="text-4xl md:text-5xl font-default font-medium text-primary">
                    {item.suffix}
                  </span>
                </div>
              </div>

              {}
              <div className="w-full">
                <Progress value={animatedValues[index].progress} className="h-1.5 bg-muted/10" />
              </div>

              {}
              <p className="text-muted-foreground text-sm leading-relaxed max-w-xs opacity-80 group-hover:opacity-100 transition-opacity duration-500 font-sans">
                {item.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}